import React from "react";
import { StyledAlert } from "./style.css";

export const AlertComponent = ({ variant, children, className }) => {
  return (
    <StyledAlert variant={variant || "success"} className={`text-center ${className || ""}`}>
      {children}
    </StyledAlert>
  );
};
